import { render, staticRenderFns } from "./CreateForms.vue?vue&type=template&id=215aa75d&scoped=true"
import script from "./CreateForms.vue?vue&type=script&lang=js"
export * from "./CreateForms.vue?vue&type=script&lang=js"
import style0 from "./CreateForms.vue?vue&type=style&index=0&id=215aa75d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215aa75d",
  null
  
)

export default component.exports